import { useTranslation } from 'react-i18next'
import { isEqual, isNull, isObject, isString } from 'lodash-es'

import { EMPTY_STRING } from '../../../constants/common'
import {
  IDWELL_TO_IDWELL_ENTITY,
  REQUEST_ENTITY,
} from '../../../constants/entity'
import { INHABITANT_STATUS_LIST } from '../../../constants/filter'
import { INHABITANT_STATUS } from '../../../constants/inhabitant'
import { REQUEST_STATUS } from '../../../constants/request'
import { ROLE_TRANSLATION_ALIASES } from '../../../constants/user'
import { stopPropagation } from '../../../utils/events'
import { getFloatLabel, isFloatListType } from '../../../utils/filter'
import { Label, LABEL_SIZE_20 } from '../../Label'
import { Tag, TAG_APPEARANCE, TAG_HEIGHT } from '../../Tag'

import { getLabelBGColor, getLabelTextColor } from './SelectTags.utils'

import * as styles from './SelectTags.module.css'

function SelectTags({ entity, listType, showTooltip, tags, onClose }) {
  const { t } = useTranslation()

  if (!tags || tags.length === 0) {
    return null
  }

  const firstTag = tags[0]

  function getLabel() {
    if (listType === 'role') {
      return t(ROLE_TRANSLATION_ALIASES[firstTag.value])
    }

    if (listType === 'status') {
      if (
        isEqual(entity, REQUEST_ENTITY) ||
        isEqual(entity, IDWELL_TO_IDWELL_ENTITY)
      ) {
        return t(REQUEST_STATUS[firstTag.value].text)
      }

      if (INHABITANT_STATUS_LIST.some(item => isEqual(entity, item))) {
        return t(INHABITANT_STATUS[firstTag.value].text)
      }

      return t(firstTag.label)
    }

    if (listType === 'attachment') {
      if (firstTag.is_persistent) {
        return t(firstTag.label.filename)
      }

      return firstTag.label.filename
    }

    if (listType === 'request') {
      if (firstTag.is_persistent) {
        return t(firstTag.label.title)
      }

      return firstTag.label.title
    }

    if (listType === 'label') {
      if (isNull(firstTag.value) || firstTag.is_persistent) {
        return t(firstTag.label.title)
      }

      return firstTag.label.title
    }

    if (listType === 'range') {
      return t(firstTag.label)
    }

    if (isFloatListType(listType)) {
      return getFloatLabel(firstTag)
    }

    if (isString(firstTag.label)) {
      if (isNull(firstTag.value) || firstTag.is_persistent) {
        return t(firstTag.label)
      }

      return firstTag.label
    }

    if (isObject(firstTag.label)) {
      if (
        isNull(firstTag.value) ||
        firstTag.label.is_system ||
        firstTag.is_persistent
      ) {
        return t(firstTag.label.fullname)
      }

      return firstTag.label.fullname
    }

    return EMPTY_STRING
  }

  const secondTagText = tags.length > 1 ? `+${tags.length - 1}` : null

  function handleCloseTag(e) {
    stopPropagation(e)

    onClose?.(firstTag)
  }

  return (
    <>
      {listType === 'label' ? (
        <Label
          backgroundColor={getLabelBGColor(firstTag.label.color)}
          className={styles.tag}
          height={LABEL_SIZE_20}
          showTooltip={showTooltip}
          text={getLabel()}
          textColor={getLabelTextColor(firstTag.label.color)}
          onRemove={handleCloseTag}
        />
      ) : (
        <Tag
          appearance={TAG_APPEARANCE.filled}
          className={styles.tag}
          height={TAG_HEIGHT.height20}
          text={getLabel()}
          onRemove={handleCloseTag}
        />
      )}
      {secondTagText ? (
        <Tag
          appearance={TAG_APPEARANCE.filled}
          className={styles.tag}
          height={TAG_HEIGHT.height20}
          text={secondTagText}
        />
      ) : null}
    </>
  )
}

export default SelectTags
